import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-164">
      <div className="max-w-4xl mx-auto" data-id="element-165">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_30px_rgba(30,142,90,0.1)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-166">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[50px] pointer-events-none" data-id="element-167"></div>

          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 rounded-full flex items-center justify-center mb-8 shadow-inner" data-id="element-168">
            <span className="text-5xl drop-shadow-[0_0_15px_rgba(30,142,90,0.4)]" data-id="element-169">
              🛡️
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-montserrat font-black text-text-main mb-6 tracking-tight" data-id="element-170">
            RISPARMIA TEMPO O TI RIMBORSIAMO
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-171">
            Hai <span className="text-primary font-bold" data-id="element-172">7 giorni</span> per
            provare{' '}
            <span className="text-text-main font-bold" data-id="element-173">BIOLOGIA PRONTA™</span>.
            Se non senti che preparare le lezioni è diventato più semplice e
            veloce, ti restituiamo il{' '}
            <span className="text-text-main font-bold" data-id="element-174">100% del pagamento</span>
            . Senza domande.
          </p>
        </div>
      </div>
    </section>;
}